/**
 * HTMLタグを除去してプレーンテキストを返す（カード・一覧の概要表示用）
 */
export function stripHtml(html: string): string {
  if (!html || typeof html !== 'string') return '';
  let text = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\s+/g, ' ')
    .trim();
  return text;
}
